import * as types from './actionTypes'
import { config, AccountData } from 'config'

const apiUrl = process.env.REACT_APP_API_URL

const handleErrors = response => {
  if (!response.ok) {
    throw Error(response.status)
  }
  return response
}

/* ------------------------------------------------------------------ */

export const loginLoading = payload => {
  return { type: types.LOGIN_LOADING, payload }
}

export const loginError = payload => {
  return { type: types.LOGIN_ERROR, payload }
}

export const loginSuccess = payload => {
  return { type: types.LOGIN_SUCCESS, payload }
}

export const getUser = (callback) => {
  return (dispatch, getState) => {
    dispatch(loginLoading())

    fetch(apiUrl, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.getElementsByTagName('meta')['csrf-token'].getAttribute('content'),
      }
    })
      .then(res => res.json())
      .catch(error => dispatch(loginError(error)))
      .then(res => {
        if(!res) {
          dispatch(loginError(res))
          return false
        }

        if(res.type && res.type === types.LOGIN_ERROR) {
          dispatch(loginError(res))
          return false
        }

        // Create progress if user start for the first time
        if(!res.progress || res.progress.length < 1) {
          const { content } = getState()
          const endtest = {
            completed: false,
            hadSeenResults: false,
            passed: false,
            score: 0,
            answers: [],
          }
          const progress = content.navigation.reduce((acc, item) => {
            const progressItem = {
              id: item.id,
              progress: 0,
              total: 0,
              status: config.linearMode ? 'locked' : 'active',
              role: item.role || 'student',
            }

            switch(item.type) {
              case 'page':
              case 'endtest':
                progressItem.total = 1
                break

              case 'chapter':
                const chapter = content.chapters.find(chpt => chpt.id === item.chapterId)
                progressItem.total = chapter.aspects.length

                if(chapter.summary) progressItem.total += 1
                break;

              default:
            }

            return acc.concat(progressItem)
          }, [])

          progress[0].status = 'active'
          const data = {
            ...AccountData,
            ...res,
            progress,
            lastProgress: progress,
            endtest
          }

          dispatch(updateAccountApi(data))
          dispatch(loginSuccess(data))
        } else {
          dispatch(loginSuccess(res))
        }

        if(callback) callback()
      })
  }
}

/* ------------------------------------------------------------------ */

export const updateAccountApiSuccess = payload => {
  return { type: types.UPDATE_ACCOUNT_API_SUCCESS, payload }
}

export const updateAccountApiError = payload => {
  return { type: types.UPDATE_ACCOUNT_API_ERROR, payload }
}

export const updateAccountApi = data => {
  return (dispatch, getState) => {
    const { account } = getState()

    fetch(apiUrl, {
      method: 'PUT',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        user: data ? data.user : account.user,
        progress: data ? data.progress : account.progress,
        lastProgress: data ? data.lastProgress : account.lastProgress,
        endtest: data ? data.endtest : account.endtest,
        chapters: data ? data.chapters : account.chapters,
      })
    })
      .then(handleErrors)
      .then(res => dispatch(updateAccountApiSuccess(res)))
      .catch(error => dispatch(updateAccountApiError(error)))
  }
}

/* ------------------------------------------------------------------ */

export const updateProgressSuccess = payload => {
  return { type: types.UPDATE_PROGRESS_SUCCESS, payload }
}

export const updateLastProgressSuccess = payload => {
  return { type: types.UPDATE_LAST_PROGRESS_SUCCESS, payload }
}

export const updateEndtestSuccess = payload => {
  return { type: types.UPDATE_ENDTEST_SUCCESS, payload }
}

export const updateChaptersSuccess = payload => {
  return { type: types.UPDATE_CHAPTERS_SUCCESS, payload }
}

export const updateProgress = (navId, progress) => {
  return (dispatch, getState) => {
    const { account } = getState()
    const navItem = account.progress.find(item => item.id === navId)
    const navItemIndex = account.progress.indexOf(navItem)
    const endtest = account.endtest

    if(navItem.status !== 'done') {
      const newNavItem = { ...navItem, progress, status: progress === navItem.total ? 'done' : endtest.completed && !endtest.passed ? 'notpassed' : 'active' }
      dispatch(updateProgressSuccess(newNavItem))

      if(newNavItem.progress === newNavItem.total) {
        const nextNavItemIndex = navItemIndex + 1
        const nextNavItem = account.progress[nextNavItemIndex]

        if(nextNavItem) {
          const newNextNavItem = { ...nextNavItem, status: nextNavItem.status === 'locked' ? 'active' : nextNavItem.status }
          dispatch(updateProgressSuccess(newNextNavItem))
        }
      }

      dispatch(updateAccountApi())
    }
  }
}

export const updateLastProgress = () => {
  return (dispatch, getState) => {
    dispatch(updateLastProgressSuccess())
    dispatch(updateAccountApi())
  }
}

export const updateEndtest = endtest => {
  return (dispatch, getState) => {
    dispatch(updateEndtestSuccess(endtest))
    dispatch(updateAccountApi())
  }
}

export const updateChapters = chapter => {
  return (dispatch, getState) => {
    dispatch(updateChaptersSuccess(chapter))
    dispatch(updateAccountApi())
  }
}

/* ------------------------------------------------------------------ */

export const logoutSuccess = payload => {
  return { type: types.LOGOUT_SUCCESS, payload }
}

export const doLogout = payload => {
  return dispatch => {
    dispatch(logoutSuccess())
  }
}

/* ------------------------------------------------------------------ */



// WEBPACK FOOTER //
// ./src/store/actions/accountActions.js